module.exports = new __parcel__URL__("product_3.4465acdf.jpeg").toString();